import { render } from "./NotFoundOrganization.vue?vue&type=template&id=f24f5e34"
import script from "./NotFoundOrganization.vue?vue&type=script&lang=js"
export * from "./NotFoundOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/NotFoundOrganization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f24f5e34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f24f5e34', __exports__)) {
    api.reload('f24f5e34', __exports__)
  }
  
  module.hot.accept("./NotFoundOrganization.vue?vue&type=template&id=f24f5e34", () => {
    api.rerender('f24f5e34', render)
  })

}


export default __exports__